module.exports = __webpack_public_path__ + "media/thePool-2023.0dcc6993.webm";